import React from 'react';
import { Button, Stack } from '@mui/material';
import { useAuth } from './AuthContext';

interface LogoutProps {
  className?: string;
}

export const LogoutButton: React.FC<LogoutProps> = ({ className }) => {
  const { userInfo } = useAuth();

  const handleLogout = async () => {
    window.location.href = '/signin'
  };

  return (
    <Stack justifyContent="flex-start" alignItems={'flex-end'}>
      <Button color="inherit" onClick={handleLogout} className={className}>
        Logout ({ userInfo?.name })
      </Button>
    </Stack>
  );
};
